export default "__VITE_ASSET__nE9iCQ7p__"